import { useEffect } from 'react'
// utils/events.ts
export const emitMutationCompleted = (detail?: any) => {
  window.dispatchEvent(new CustomEvent('mutation:complete', { detail }))
}


export function useMutationComplete(callback: (detail: any) => void) {
  useEffect(() => {
    const handler = (e: CustomEvent) => {
      callback(e.detail)
    }

    window.addEventListener('mutation:complete', handler as EventListener)

    return () => {
      window.removeEventListener('mutation:complete', handler as EventListener)
    }
  }, [callback])
}